export interface PhoenixSubscription {
    Id:number;
    IsInherited:boolean;
    Links:{
        SettingsUri:string;
    },
    Name:string;
    Settings:{
        Comments:boolean;
        Deletes:boolean;
        Downloads:boolean;
        Edits:boolean;
        Previews:boolean;
        Shares:boolean;
    }
    type:'document' | 'folder';
    UserId:number;
}

export interface NotificationSettingsParameter {
    Owned: boolean;
    Shared: boolean;
}

/**
 * Available values for the email digest frequency settings.
 */
export enum DigestFrequency {
    // Values are represented in minutes
    Never = 0,
    Hourly = 60,
    Daily = DigestFrequency.Hourly * 24,
    Weekly = DigestFrequency.Daily * 7
}

export interface TimeSpanParameter {
    Hours: number;
    Minutes: number;
    Seconds: number;
}

export interface PhoenixSubscriptionSettings {
    Downloads: NotificationSettingsParameter;
    Uploads: NotificationSettingsParameter;
    Edits: NotificationSettingsParameter;
    Comments: NotificationSettingsParameter;
    Previews: NotificationSettingsParameter;
    Deletes: NotificationSettingsParameter;
    Shares: NotificationSettingsParameter;
    EnableDigest: boolean;
    NotificationFrequency: DigestFrequency;
    DigestDayOfWeek: number;
    DigestTimeOfDay: TimeSpanParameter;
}



// WEBPACK FOOTER //
// ./src/phoenix/domain/phoenix-subscription.ts